import { ApiResponse } from 'apisauce';
import { ErrorInfo } from '../../../shared/interfaces/error-info.interface';
import { ResponseModel } from '../../../shared/interfaces/response-model.interface';
import { CityModel } from '../../../shared/models/city.model';
import api from '../../../shared/services/utils/api/api.service';
import errorHelper from '../../../shared/services/utils/api/error-helper.service';
import { MODULE_NAME } from '../config/city-module.config';

export function updateCity(
  cityId: string,
  cityData: Pick<CityModel, 'name' | 'nameAr'>
): Promise<CityModel | ErrorInfo> {
  return api
    .updateCity(cityId, cityData)
    .then((response: ApiResponse<ResponseModel<CityModel>, ErrorInfo>) => {
      if (response.ok) {
        const { data } = response;
        if (data && data.data) {
          return data.data;
        } else {
          return errorHelper(0, '', MODULE_NAME, (api.updateCity as any).displayName);
        }
      } else {
        return errorHelper(
          Number(response.status),
          response.data && response.data.errorCode
            ? String(response.data.errorCode || '')
            : response.problem,
          MODULE_NAME,
          (api.updateCity as any).displayName
        );
      }
    });
}
